module.exports = __webpack_public_path__ + "95aac32683f47cdec7000809797739f4.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/notes/add/add-note.html
// module id = 2423
// module chunks = 0